import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

const ALLOWED_ROUTES = ['Auth:MfaSetup', 'Auth:Logout']

// While the backend requires MFA enrollment (enforcementRequired), the user
// is in a restricted authenticated state: only the enrollment screen and
// logout may be reached. The backend independently blocks protected
// operations; this middleware covers client-side navigation.
export default new Middleware('MFA enforcement', ({ to, next }) => {
	const mfa = store.getters['Auth/mfa']

	// Once MFA is verified as enabled, enforcement no longer blocks navigation.
	if (!mfa?.enforcementRequired || mfa?.enabled) {
		return next()
	}

	if (ALLOWED_ROUTES.includes(to.name)) {
		return next()
	}

	return next({
		name: 'Auth:MfaSetup',
		query: { redirect: to.fullPath }
	})
})
